import PropTypes from 'prop-types';
import Label from 'infrastructure/js/components/Label/label.js';
import Tooltip from 'infrastructure/js/components/tooltip/tooltip';

function LabelWithStyleAndTooltipCell({value = null}) {
  let label = value?.label || '';
  let style = value?.style || null;
  let tooltip = value?.tooltip || null;

  let content = (
    <div style={{display: 'inline-block', ...style}}>
      <Label text={label} />
    </div>
  );

  if (!tooltip) {
    return content;
  }

  return (
    <Tooltip placement="top" value={tooltip}>
      {content}
    </Tooltip>
  );
}

LabelWithStyleAndTooltipCell.propTypes = {
  value: PropTypes.shape({
    label: PropTypes.any,
    style: PropTypes.object,
    tooltip: PropTypes.string,
  }),
};

export default LabelWithStyleAndTooltipCell;
